export default function checkHasAudio(video) {
  return !!video.mozHasAudio || !!video.webkitAudioDecodedByteCount || video.audioTracks?.length > 0;
}
